{
  "name": "vfu",
  "version": "19.45.0",
  "scripts": {
    "analyzebundle": "webpack-bundle-analyzer dist/stats.json",
    "build": "cross-env NODE_ENV=production ng build --configuration prod",
    "build:analyze": "ng build --configuration prod --verbose --named-chunks=true && esbuild-visualizer --metadata ./dist/stats.json --filename ./dist/stats.html --open",
    "build:srs-vetmanager": "cross-env NODE_ENV=production ng build --configuration srs-vetmanager",
    "build:srs-provet": "cross-env NODE_ENV=production ng build --configuration srs-provet",
    "build:srs-vetz": "cross-env NODE_ENV=production ng build --configuration srs-vetz",
    "build:srs-myvete": "cross-env NODE_ENV=production ng build --configuration srs-myvete",
    "build:das-gmvet": "cross-env NODE_ENV=production ng build --configuration das-gmvet",
    "ci:quality": "npm run lint:scripts && npm run lint:styles && npm run prettier:check",
    "compodoc": "npx compodoc -p tsconfig.json src -s",
    "env:prepare": "import-meta-env-prepare -x ./.env.example",
    "env:prepare-srs-vetmanager": "import-meta-env-prepare -x ./.env.example -p ./.env.local.defaults -p ./.env.srs-vetmanager.local.defaults",
    "env:prepare-das-gmvet": "import-meta-env-prepare -x ./.env.example -p ./.env.local.defaults -p ./.env.das-gmvet.local.defaults",
    "env:prepare-srs-myvete": "import-meta-env-prepare -x ./.env.example -p ./.env.local.defaults -p ./.env.srs-myvete.local.defaults",
    "env:prepare-srs-provet": "import-meta-env-prepare -x ./.env.example -p ./.env.local.defaults -p ./.env.srs-provet.local.defaults",
    "env:prepare-srs-vetz": "import-meta-env-prepare -x ./.env.example -p ./.env.local.defaults -p ./.env.srs-vetz.local.defaults",
    "env:type": "import-meta-env-typescript -x ./.env.example -o ./src/",
    "generate-icons": "svg-to-ts-files && prettier ./src/app/shared/utils/icon --write",
    "lhci-static": "lhci autorun --config=./lighthouseConfigs/lighthouserc-static.js",
    "lint:scripts": "ng lint",
    "lint:styles": "stylelint \"**/*.scss\" --fix",
    "lint:staged": "lint-staged",
    "ng": "ng",
    "prestart": "npm run env:prepare",
    "prestart:srs-vetmanager": "npm run env:prepare-srs-vetmanager",
    "prestart:das-gmvet": "npm run env:prepare-das-gmvet",
    "prestart:srs-myvete": "npm run env:prepare-srs-myvete",
    "prestart:srs-provet": "npm run env:prepare-srs-provet",
    "prestart:srs-vetz": "npm run env:prepare-srs-vetz",
    "prettier:check": "prettier ./src --check",
    "prettier:write": "prettier ./src --write",
    "sonar": "sonar-scanner",
    "start": "cross-env NODE_ENV=development ng serve",
    "start:srs-vetmanager": "cross-env NODE_ENV=development ng serve --configuration=srs-vetmanager",
    "start:das-gmvet": "cross-env NODE_ENV=development ng serve --configuration=das-gmvet",
    "start:srs-myvete": "cross-env NODE_ENV=development ng serve --configuration=srs-myvete",
    "start:srs-provet": "cross-env NODE_ENV=development ng serve --configuration=srs-provet",
    "start:srs-vetz": "cross-env NODE_ENV=development ng serve --configuration=srs-vetz",
    "test": "jest --maxWorkers=50% --detect-open-handles",
    "ci:test": "jest --ci --coverage --runInBand --coverageReporters=cobertura --coverageReporters=lcov --testResultsProcessor=jest-sonar-reporter --no-cache",
    "types:check": "tsc --noEmit",
    "template:da": "ts-node --project tsconfig-node.json templates/script.ts daily-allowance && prettier ./src/**/templates/**/daily-allowance**/*.html --write",
    "template:sr": "ts-node --project tsconfig-node.json templates/script.ts smart-reco && prettier ./src/**/templates/**/smart-reco**/*.html --write",
    "template:rr": "ts-node --project tsconfig-node.json templates/script.ts rapid-reco && prettier ./src/**/templates/**/rapid-reco**/*.html --write",
    "template:rsr": "ts-node --project tsconfig-node.json templates/script.ts renal-smart-reco && prettier ./src/**/templates/**/renal-smart-reco**/*.html --write",
    "template:dar": "ts-node --project tsconfig-node.json templates/script.ts daily-renal-detect && prettier ./src/**/templates/**/daily-renal-detect**/*.html --write",
    "template:wl": "ts-node --project tsconfig-node.json templates/script.ts weight-loss && prettier ./src/**/templates/**/weight-loss**/*.html --write",
    "template:all": "npm run template:da && npm run template:sr && npm run template:rr && npm run template:rsr && npm run template:dar && npm run template:wl",
    "emails:aoi": "./node_modules/.bin/mjml ./emails/automatic-onboarding-invitation/source.mjml -o ./emails/automatic-onboarding-invitation/output.html",
    "prepare": "husky",
    "requirements-check": "ts-node check-version.mjs",
    "postinstall": "npm run requirements-check",
    "copy-pdfjs-worker": "cp node_modules/pdfjs-dist/build/pdf.worker.min.mjs src/assets/pdfjs-worker/pdf.worker.min.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.1.6",
    "@angular/cdk": "^19.1.5",
    "@angular/common": "^19.1.6",
    "@angular/compiler": "^19.1.6",
    "@angular/core": "^19.1.6",
    "@angular/forms": "^19.1.6",
    "@angular/localize": "^19.1.6",
    "@angular/material": "^19.1.5",
    "@angular/material-date-fns-adapter": "^19.1.5",
    "@angular/platform-browser": "^19.1.6",
    "@angular/platform-browser-dynamic": "^19.1.6",
    "@angular/router": "^19.1.6",
    "@grafana/faro-web-sdk": "^1.5.0",
    "@microsoft/applicationinsights-web": "^2.8.9",
    "@ngrx/effects": "19.0.1",
    "@ngrx/operators": "19.0.1",
    "@ngrx/router-store": "19.0.1",
    "@ngrx/schematics": "19.0.1",
    "@ngrx/store": "19.0.1",
    "@ngrx/store-devtools": "19.0.1",
    "@okta/okta-angular": "6.3.2",
    "@okta/okta-auth-js": "^7.14.0",
    "@rc-df/ds-foundation-tokens": "^3.1.1",
    "@rc-df/ds-icons": "^0.9.2",
    "@rc-df/ds-web-components": "^1.36.0",
    "@rc/ui": "^19.1.2",
    "d3": "^7.9.0",
    "date-fns": "^2.29.3",
    "handlebars": "^4.7.8",
    "ngrx-store-localstorage": "^19.0.0",
    "ngx-cookie-service": "^19.1.0",
    "object-path": "^0.11.8",
    "pdfjs-dist": "^4.10.38",
    "qrcode": "^1.5.4",
    "rxjs": "^7.8.1",
    "semver": "^7.6.3",
    "tslib": "^2.7.0",
    "utf-8-validate": "^5.0.10",
    "uuid": "^9.0.0",
    "validator": "^13.12.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-builders/custom-esbuild": "^19.0.0",
    "@angular-builders/dev-server": "^7.3.1",
    "@angular-devkit/architect": "^0.1901.7",
    "@angular-devkit/build-angular": "^19.1.7",
    "@angular-eslint/builder": "^19.1.0",
    "@angular-eslint/eslint-plugin": "^19.1.0",
    "@angular-eslint/eslint-plugin-template": "^19.1.0",
    "@angular-eslint/schematics": "^19.1.0",
    "@angular-eslint/template-parser": "^19.1.0",
    "@angular/cli": "^19.1.7",
    "@angular/compiler-cli": "^19.1.6",
    "@angular/language-service": "^19.1.6",
    "@babel/core": "^7.26.10",
    "@babel/preset-env": "^7.26.9",
    "@babel/preset-typescript": "^7.26.0",
    "@compodoc/compodoc": "^1.1.26",
    "@dotenv-run/esbuild": "^1.5.0",
    "@import-meta-env/babel": "^0.5.0",
    "@import-meta-env/cli": "^0.7.3",
    "@import-meta-env/prepare": "^0.2.2",
    "@import-meta-env/typescript": "^0.4.0",
    "@import-meta-env/unplugin": "^0.6.2",
    "@ngx-env/builder": "^19.0.4",
    "@rxweb/types": "^1.0.8",
    "@types/d3": "^7.4.3",
    "@types/jest": "^29.5.14",
    "@types/node": "^18.11.11",
    "@types/qrcode": "^1.5.5",
    "@types/validator": "^13.12.2",
    "@typescript-eslint/eslint-plugin": "^8.5.0",
    "@typescript-eslint/parser": "^8.5.0",
    "babel-jest": "^29.7.0",
    "cross-env": "^7.0.3",
    "dotenv": "^16.4.7",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "^ 9.20.1",
    "eslint-config-prettier": "^10.0.1",
    "eslint-plugin-import": "2.31.0",
    "eslint-plugin-jsdoc": "^50.6.3",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "eslint-plugin-prettier": "^5.2.3",
    "eslint-plugin-unused-imports": "^4.1.4",
    "html-webpack-plugin": "^5.6.3",
    "husky": "^9.1.7",
    "i18n-iso-countries": "^7.12.0",
    "jest": "^29.7.0",
    "jest-extended": "^4.0.2",
    "jest-marbles": "3.0.6",
    "jest-preset-angular": "^14.2.4",
    "jest-sonar-reporter": "^2.0.0",
    "libphonenumber-js": "^1.12.7",
    "lint-staged": "^15.2.10",
    "mjml": "^4.15.3",
    "ng-mocks": "^14.13.2",
    "prettier": "3.5.1",
    "sass": "^1.78.0",
    "sonarqube-scanner": "^2.7.0",
    "stylelint": "^16.14.1",
    "stylelint-config-sass-guidelines": "^12.1.0",
    "stylelint-config-standard": "^37.0.0",
    "stylelint-prettier": "^5.0.3",
    "svg-to-ts": "^12.0.0",
    "ts-jest": "^29.2.5",
    "ts-node": "^10.9.2",
    "typescript": "~5.7.0",
    "webpack-bundle-analyzer": "^4.10.2"
  },
  "engines": {
    "node": ">=22.18",
    "npm": ">=10.5"
  }
}
